import { useEffect } from "react";
import RoutesPage from "./Routes";
import FormRendererContextProvider from "./services/context/FormRendererContextProvider";
import CssBaseline from "@mui/material/CssBaseline";
import ThemeSelectorContextProvider from "./services/context/ThemeSelectorContextProvider";
import ScrollToTop from "./utils/scrollTop";
import { getClientConfig } from "./config/clientConfig";

function App() {
  useEffect(() => {
    const config = getClientConfig();

    // Page title
    document.title = config.pageTitle;

    // Meta description
    document.querySelector('meta[name="description"]')?.setAttribute("content", config.description);

    // Theme color
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", config.themeColor);

    // Open Graph tags
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", config.pageTitle);
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", config.description);
    document.querySelector('meta[property="og:image"]')?.setAttribute("content", config.ogImage);
    document.querySelector('meta[property="og:url"]')?.setAttribute("content", config.ogUrl);

    // Favicon — respect dark mode for HealthBlox; use single icon for clients
    const applyFavicon = () => {
      const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      const icon96 = isDark && config.favicon96Dark ? config.favicon96Dark : config.favicon96;
      const icon192 = isDark && config.favicon192Dark ? config.favicon192Dark : config.favicon192;
      document.getElementById("favicon")?.setAttribute("href", icon96);
      document.getElementById("apple-touch-icon")?.setAttribute("href", icon192);
    };
    applyFavicon();
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    mq.addEventListener ? mq.addEventListener("change", applyFavicon) : mq.addListener(applyFavicon);

    // Dynamic PWA manifest so manifest.json is also client-specific
    const manifestData = {
      short_name: config.shortName,
      name: config.pageTitle,
      icons: [
        { src: config.favicon96, sizes: "96x96", type: "image/png" },
        { src: config.favicon192, sizes: "192x192", type: "image/png" },
      ],
      start_url: ".",
      display: "standalone",
      theme_color: config.themeColor,
      background_color: config.backgroundColor,
    };
    const blob = new Blob([JSON.stringify(manifestData)], { type: "application/json" });
    const manifestUrl = URL.createObjectURL(blob);
    document.querySelector('link[rel="manifest"]')?.setAttribute("href", manifestUrl);

    return () => {
      mq.removeEventListener ? mq.removeEventListener("change", applyFavicon) : mq.removeListener(applyFavicon);
      URL.revokeObjectURL(manifestUrl);
    };
  }, []);
  return (
    <ThemeSelectorContextProvider>
    <FormRendererContextProvider>
        <CssBaseline />
        <div className="app">
          <ScrollToTop />
          <RoutesPage />
        </div>
    </FormRendererContextProvider>
    </ThemeSelectorContextProvider>
  );
}

export default App;
